module.exports = __webpack_public_path__ + "assets/img/IMG031.9f8cc1fc.png";